import React from "react";
import { useSelector } from "react-redux";
import './EnhancedErrorModal.scss';

const selector = state => {
    const { language } = state;
    return {
        t: language.translator
    }
};

const EnhancedErrorModal = props => {
    const { error, closeMethod, requestFailed, closeText } = props;
    const { t } = useSelector(selector);

    const closeModal = () => {
        closeMethod();
    };

    return(
        <div
            className='errorModalBlur'
            onClick={e => {
                if(e.target.className === 'errorModalBlur') {
                    closeModal()
                }
            }}
        >
            <div className='enhancedErrorModalWindow'>
                <div className='errorText'>
                    {error}
                </div>
                <button
                    style={requestFailed ? {background: 'red'} : null}
                    className='confirmationButton'
                    onClick={e => {
                        e.preventDefault();
                        closeModal();
                    }}
                >
                    {closeText ? closeText : t.gettext('Close')}
                </button>
            </div>
        </div>
    );
};

export default EnhancedErrorModal;
